import React, { ReactNode } from 'react';
import { Field } from 'react-final-form';
import { useIntl } from 'react-intl';

import { Input, InputProps, ValidationMessage } from '@xsolla/ui-core';

import { FlexParentBlock, SpaceBetweenBlock } from '../../../styled';
import { ExtraFieldLink, FieldInputTitle, FullWideContentBlock, InputSubLabel } from './style';

type Props = InputProps & {
  name: string;
  label?: ReactNode;
  extraRight?: ReactNode;
  additional?: ReactNode;
  subLabel?: ReactNode;
  extraLink?: {
    title: ReactNode;
    to: string;
  };
  ignoreErrorMeta?: boolean;
};

const FieldInput = ({
  label,
  extraRight,
  errorMessage,
  name,
  additional,
  subLabel,
  extraLink,
  ignoreErrorMeta = false,
  ...props
}: Props): JSX.Element => {
  const intl = useIntl();

  return (
    <div>
      <SpaceBetweenBlock>
        <FieldInputTitle>{label}</FieldInputTitle>
        {additional && <div>{additional}</div>}
      </SpaceBetweenBlock>
      <FlexParentBlock>
        <FullWideContentBlock>
          <Field name={name}>
            {({ input, meta }) => (
              <>
                <Input
                  name={input.name}
                  value={input.value}
                  spellCheck={false}
                  onChange={(e) => {
                    input.onChange(e.target.value || null);
                  }}
                  {...props}
                />

                {subLabel && <InputSubLabel>{subLabel}</InputSubLabel>}

                {extraLink && (
                  <ExtraFieldLink href={extraLink.to} target="_blank">
                    {extraLink.title}
                  </ExtraFieldLink>
                )}
                <ValidationMessage>
                  {ignoreErrorMeta
                    ? errorMessage
                    : (meta.modified || meta.submitFailed) &&
                      (errorMessage || (meta.error && intl.formatMessage({ id: meta.error })))}
                </ValidationMessage>
              </>
            )}
          </Field>
        </FullWideContentBlock>
        {extraRight}
      </FlexParentBlock>
    </div>
  );
};

export default FieldInput;
